<ng-container class="root-container" *ngIf="rows?.length > 0;">
  <h5 class="mt-4"> {{ heading }} </h5>

  <ng-container *ngFor="let group of rows">
    <table *ngIf="type === 'Item'" class="styled-table">
      <thead>
        <tr>
          <th>{{ group.name }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of group.items">
          <td>{{ item }}</td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <table *ngIf="type !== 'Item'" class="table table-bordered ad-text-size ">
    <thead>
      <tr>
        <th *ngFor="let col of columns">{{ col }}</th>
        <th *ngIf="actionColumn">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows; let i = index">

        <!-- Regular columns -->
        <td *ngFor="let col of columns">
          <!-- Unit column with dropdown if enabled and row has unit data -->
          <ng-container *ngIf="isUnitDropdownColumn(col) && isUnitDataRow(row); else regularValue">
            <select class="form-select form-select-sm" 
                    [ngModel]="selectedUnits[i]" 
                    (ngModelChange)="onUnitChange(i, $event)">
              <option *ngFor="let unit of getAvailableUnits(row)" [value]="unit">
                {{ unit }}
              </option>
            </select>
          </ng-container>
          <ng-template #regularValue>
            {{ getValue(row, col, i) }}
          </ng-template>
        </td>
        
        <!-- Action column if enabled -->
        <td *ngIf="actionColumn">
          <div class="actnbtn btn-danger" (click)="onActionClick(i)" 
               style="cursor:pointer; width: 30px; height: 30px; display:flex; align-items:center; justify-content:center;">
            <i class="fa" [ngClass]="actionIcon"></i>
          </div>
        </td>

      </tr>
    </tbody>
  </table>
</ng-container>
